<template>
    <WarehousesList/>
</template>

<script>
import WarehousesList from '../../components/warehouses/WarehousesList';

export default {
  components: {
    WarehousesList,
  },
};
</script>
